(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aa-selected-5sep"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    const recentKey = 'aa-fashion-recent-v1';
    const whatsappIcon = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a9.8 9.8 0 0 0-8.44 14.78L2.2 21.8l5.14-1.35A9.8 9.8 0 1 0 12 2Zm0 17.8a8 8 0 0 1-4.08-1.11l-.29-.17-3.05.8.81-2.97-.19-.3A8 8 0 1 1 12 19.8Zm4.39-5.99c-.24-.12-1.42-.7-1.64-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-1.01-.37-1.93-1.19-.71-.64-1.2-1.42-1.34-1.66-.14-.24-.01-.37.11-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.19-.47-.39-.41-.54-.42h-.46c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.69 2.58 4.1 3.62.57.25 1.02.39 1.37.5.58.18 1.1.16 1.51.1.46-.07 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28Z"/></svg>';

    const readRecent = () => {
      try {
        const value = JSON.parse(localStorage.getItem(recentKey));
        return Array.isArray(value) ? value : [];
      } catch (_) {
        return [];
      }
    };

    const writeRecent = (items) => {
      try {
        localStorage.setItem(recentKey, JSON.stringify(items));
      } catch (_) {}
    };

    const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    })[character]);

    const normalizeUrl = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin ? url.pathname : '/collections/all';
      } catch (_) {
        return '/collections/all';
      }
    };

    const visiblePrice = (scope) => {
      const price = scope?.querySelector('.price');
      if (!price) return '';
      const selector = price.classList.contains('price--on-sale')
        ? '.price__sale .price-item--sale'
        : '.price__regular .price-item--regular';
      return (price.querySelector(selector)?.textContent || '').replace(/\s+/g, ' ').trim();
    };

    const productInfo = () => document.querySelector('.product__info-container, product-info');
    const productTitle = (scope) => (scope?.querySelector('.product__title h1, h1')?.textContent || '').trim();
    const productImage = () => document.querySelector('.product__media img, .product-media-container img')?.currentSrc
      || document.querySelector('.product__media img, .product-media-container img')?.src
      || document.querySelector('meta[property="og:image"]')?.content
      || '';

    function addWhatsAppInquiry(scope) {
      if (!scope || scope.querySelector('.aa5-product-actions')) return;
      const source = document.querySelector('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
      if (!source) return;
      const title = productTitle(scope);
      if (!title) return;

      let base;
      try {
        const url = new URL(source.href);
        base = `${url.origin}${url.pathname}`;
      } catch (_) {
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'aa5-product-actions';
      const link = document.createElement('a');
      link.className = 'aa5-whatsapp-inquiry';
      link.target = '_blank';
      link.rel = 'noopener';
      link.href = `${base}?text=${encodeURIComponent(`Assalam-o-Alaikum, mujhe ${title} ke baray mein details chahiye: ${window.location.href}`)}`;
      const labels = document.getElementById('aa-order-labels');
      link.innerHTML = whatsappIcon;
      const caption = document.createElement('span');
      caption.textContent = labels?.dataset.whatsappEn || '';
      const urdu = document.createElement('span');
      urdu.lang = 'ur';
      urdu.dir = 'rtl';
      urdu.textContent = labels?.dataset.whatsappUr || '';
      caption.appendChild(urdu);
      link.appendChild(caption);
      wrapper.appendChild(link);

      const form = scope.querySelector('product-form, .product-form');
      if (form) form.insertAdjacentElement('afterend', wrapper);
      else scope.appendChild(wrapper);
    }

    function createMobileAtc(scope) {
      if (!scope || document.querySelector('.aa5-mobile-atc')) return;
      const original = scope.querySelector('.product-form__submit, product-form button[name="add"], button[name="add"]');
      const title = productTitle(scope);
      if (!original || !title) return;

      const bar = document.createElement('div');
      bar.className = 'aa5-mobile-atc';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = `<div class="aa5-mobile-atc__meta"><span class="aa5-mobile-atc__title">${escapeHtml(title)}</span><span class="aa5-mobile-atc__price">${escapeHtml(visiblePrice(scope))}</span></div><button type="button" class="button" ${original.disabled ? 'disabled' : ''}>${escapeHtml(window.variantStrings?.addToCart || 'Add to cart')}</button>`;
      document.body.appendChild(bar);
      document.body.classList.add('aa5-has-mobile-atc');

      const syncFloatingOffsets = () => {
        const height = Math.ceil(bar.getBoundingClientRect().height);
        if (height > 0) document.documentElement.style.setProperty('--aa5-mobile-atc-height', `${height}px`);
      };

      requestAnimationFrame(syncFloatingOffsets);
      window.addEventListener('resize', syncFloatingOffsets, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(syncFloatingOffsets).observe(bar);

      const stickyButton = bar.querySelector('button');
      stickyButton.dataset.aaSmart = '';
      stickyButton.addEventListener('click', () => {
        const current = scope.querySelector('.product-form__submit, product-form button[name="add"], button[name="add"]');
        if (current && !current.disabled && current.getAttribute('aria-disabled') !== 'true') current.click();
      });

      const sync = () => {
        const current = scope.querySelector('.product-form__submit, product-form button[name="add"], button[name="add"]');
        bar.querySelector('.aa5-mobile-atc__title').textContent = productTitle(scope);
        bar.querySelector('.aa5-mobile-atc__price').textContent = visiblePrice(scope);
        stickyButton.disabled = Boolean(current?.disabled || current?.getAttribute('aria-disabled') === 'true');
        stickyButton.dataset.aaCartState = current?.dataset.aaCartState || 'idle';
        stickyButton.setAttribute('aria-busy', String(current?.dataset.aaCartState === 'adding'));
        stickyButton.textContent = current?.querySelector('span')?.textContent?.trim()
          || window.variantStrings?.addToCart
          || 'Add to cart';
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const visible = !entries[0].isIntersecting;
          bar.classList.toggle('is-visible', visible);
          bar.setAttribute('aria-hidden', String(!visible));
          document.body.classList.toggle('aa5-atc-visible', visible);
          if (visible) requestAnimationFrame(syncFloatingOffsets);
        }, { threshold: 0.1 });
        observer.observe(original);
      }

      let syncFrame;
      const mutation = new MutationObserver(() => {
        if (syncFrame) return;
        syncFrame = requestAnimationFrame(() => {
          syncFrame = undefined;
          sync();
        });
      });
      mutation.observe(scope, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'data-aa-cart-state', 'class']
      });
      sync();
    }

    function storeAndRenderRecent(scope) {
      if (!scope) return;
      const title = productTitle(scope);
      if (!title) return;
      const current = {
        url: normalizeUrl(window.location.href),
        title,
        image: productImage(),
        price: visiblePrice(scope)
      };
      const previous = readRecent().filter((item) => normalizeUrl(item.url) !== current.url);
      writeRecent([current, ...previous].slice(0, 8));
      renderRecent(current.url);
    }

    function renderRecent(currentUrl) {
      if (document.querySelector('.aa5-recently-viewed')) return;
      const items = readRecent()
        .filter((item) => normalizeUrl(item.url) !== currentUrl)
        .slice(0, 4);
      if (!items.length) return;

      const section = document.createElement('section');
      section.className = 'aa5-recently-viewed';
      section.setAttribute('aria-labelledby', 'aa5-recent-heading');
      section.innerHTML = `<div class="page-width"><div class="aa5-recently-viewed__head"><h2 id="aa5-recent-heading">Recently Viewed</h2></div><div class="aa5-recently-viewed__grid">${items.map((item) => `<a class="aa5-recent-card" href="${normalizeUrl(item.url)}">${item.image ? `<div class="aa5-recent-card__media"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy" decoding="async"></div>` : ''}<span class="aa5-recent-card__title">${escapeHtml(item.title)}</span><span class="aa5-recent-card__price">${escapeHtml(item.price)}</span></a>`).join('')}</div></div>`;
      const footer = document.querySelector('footer');
      if (footer?.parentNode) footer.parentNode.insertBefore(section, footer);
      else document.querySelector('main')?.appendChild(section);
    }

    function createBackToTop() {
      if (document.querySelector('.aa5-back-top')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'aa5-back-top';
      button.setAttribute('aria-label', 'Back to top');
      button.innerHTML = '<svg class="aa5-back-top__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="m7 14 5-5 5 5M7 19l5-5 5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      document.body.appendChild(button);

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      button.addEventListener('click', () => window.scrollTo({
        top: 0,
        behavior: reducedMotion ? 'auto' : 'smooth'
      }));

      let ticking = false;
      const update = () => {
        const pageHeight = Math.max(
          document.documentElement.scrollHeight,
          document.body.scrollHeight
        );
        const maxScroll = Math.max(pageHeight - window.innerHeight, 1);
        const progress = Math.min(100, Math.max(0, (window.scrollY / maxScroll) * 100));
        const visibilityThreshold = Math.min(
          500,
          Math.max(120, maxScroll * 0.1),
          maxScroll * 0.35
        );
        button.style.setProperty('--aa5-scroll-progress', `${progress.toFixed(2)}%`);
        button.classList.toggle('is-past-half', progress >= 52);
        button.classList.toggle(
          'is-visible',
          maxScroll > 32 && window.scrollY > visibilityThreshold
        );
        ticking = false;
      };
      const requestUpdate = () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      };
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      window.addEventListener('load', requestUpdate, { once: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(requestUpdate).observe(document.documentElement);
      }
      update();
    }

    function enhanceProduct() {
      const scope = productInfo();
      if (!scope) return;
      addWhatsAppInquiry(scope);
      createMobileAtc(scope);
      if (!document.documentElement.dataset.aa5RecentStored) {
        document.documentElement.dataset.aa5RecentStored = 'true';
        storeAndRenderRecent(scope);
      }
    }

    function init() {
      enhanceProduct();
      createBackToTop();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();

    document.addEventListener('shopify:section:load', init);
    const main = document.querySelector('main');
    if (main && productTitle(productInfo())) {
      let initFrame;
      const selector = 'product-info, .product__info-container, product-form';
      const observer = new MutationObserver((records) => {
        const productAdded = records.some(record => [...record.addedNodes].some(node =>
          node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
        ));
        if (!productAdded || initFrame) return;
        initFrame = requestAnimationFrame(() => {
          initFrame = undefined;
          enhanceProduct();
        });
      });
      observer.observe(main, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aa-wishlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-wishlist')) {
    customElements.define('aa-wishlist', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.key = 'aa-fashion-wishlist-v1';
        this.dialog = this.querySelector('dialog');
        this.list = this.querySelector('[data-aa-wish-list]');
        this.status = this.querySelector('[data-aa-wish-status]');
        this.dialogStatus = this.querySelector('[data-aa-wish-dialog-status]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.events = new AbortController();
        this.items = this.read();
        document.addEventListener('click', (event) => this.click(event), { signal: this.events.signal });
        window.addEventListener('storage', (event) => {
          if (event.key === this.key || event.key === null) {
            this.items = this.read();
            this.sync();
            if (this.dialog.open) this.render();
          }
        }, { signal: this.events.signal });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('aa-wishlist-open');
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, { signal: this.events.signal });
        this.observer = new MutationObserver((records) => {
          if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-aa-wish-toggle], [data-aa-wish-open]') || node.querySelector('[data-aa-wish-toggle], [data-aa-wish-open]'))))) this.sync();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.sync();
      }
      clean(item) {
        if (!item || !/^\d+$/.test(String(item.id)) || typeof item.title !== 'string' || typeof item.url !== 'string') return null;
        try {
          const url = new URL(item.url, location.origin);
          if (url.origin !== location.origin || !url.pathname.includes('/products/')) return null;
          let image = '';
          if (typeof item.image === 'string' && item.image) {
            const source = new URL(item.image, location.origin);
            if (source.protocol === 'https:' && (source.hostname === 'cdn.shopify.com' || source.origin === location.origin)) image = source.href;
          }
          return { id: String(item.id), title: item.title.slice(0,300), url: url.pathname + url.search, image };
        } catch { return null; }
      }
      read() {
        try {
          const values = JSON.parse(localStorage.getItem(this.key) || '[]');
          if (!Array.isArray(values)) return [];
          const unique = new Map();
          values.slice(0,100).forEach(value => { const item = this.clean(value); if (item) unique.set(item.id,item); });
          return [...unique.values()];
        } catch { return []; }
      }
      persist() {
        try { localStorage.setItem(this.key, JSON.stringify(this.items)); return true; }
        catch { return false; }
      }
      sync() {
        document.querySelectorAll('[data-aa-wish-toggle]').forEach(button => {
          const saved = this.items.some(item => item.id === button.dataset.id);
          button.hidden = false;
          button.setAttribute('aria-pressed', String(saved));
          button.setAttribute('aria-label', `${saved ? this.dataset.remove : this.dataset.save}: ${button.dataset.title}`);
          const label = button.querySelector('.aa-wish-toggle__text');
          if (label) label.textContent = saved ? this.dataset.saved : this.dataset.save;
        });
        document.querySelectorAll('[data-aa-wish-open]').forEach(button => {
          button.hidden = false;
          button.setAttribute('aria-label', `${this.dataset.title} (${this.items.length})`);
          const count = button.querySelector('[data-aa-wish-count]');
          if (count) { count.textContent = String(this.items.length); count.hidden = !this.items.length; }
        });
      }
      celebrate(source) {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || typeof Element.prototype.animate !== 'function') return;
        const icon = source.querySelector('svg');
        if (!icon) return;
        const origin = icon.getBoundingClientRect();
        if (!origin.width || !origin.height) return;
        const start = { x: origin.left + origin.width / 2, y: origin.top + origin.height / 2 };
        this.flightLayer?.remove();
        const layer = document.createElement('div');
        layer.className = 'aa-wish-fx';
        layer.setAttribute('aria-hidden', 'true');
        document.body.append(layer);
        this.flightLayer = layer;
        const animations = [];
        const animate = (element, frames, options) => {
          const animation = element.animate(frames, { fill: 'both', ...options });
          animations.push(animation.finished.catch(() => {}));
          return animation;
        };
        const piece = (kind) => {
          const node = document.createElement('span');
          node.className = 'aa-wish-fx__piece' + (kind === 'heart' ? ' aa-wish-fx__heart' : kind === 'ring' ? ' aa-wish-fx__ring' : '');
          if (kind === 'heart') node.append(icon.cloneNode(true));
          if (kind === 'spark') {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '0 0 24 24');
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('d', 'M12 1 15 9 23 12 15 15 12 23 9 15 1 12 9 9Z');
            svg.append(path); node.append(svg);
          }
          layer.append(node);
          return node;
        };
        const pose = (x, y, size, scale = 1, angle = 0) => `translate3d(${x-size/2}px,${y-size/2}px,0) rotate(${angle}deg) scale(${scale})`;
        const burst = (point, count, radius, delay = 0) => {
          for (let i = 0; i < count; i++) {
            const angle = (i / count) * Math.PI * 2;
            const distance = radius * (i % 2 ? .72 : 1);
            animate(piece('spark'), [
              { transform: pose(point.x, point.y, 12, .1), opacity: 0 },
              { offset: .2, transform: pose(point.x + Math.cos(angle)*distance*.35, point.y + Math.sin(angle)*distance*.35, 12, 1), opacity: 1 },
              { transform: pose(point.x + Math.cos(angle)*distance, point.y + Math.sin(angle)*distance + 8, 12, .1, 80), opacity: 0 }
            ], { duration: 520, delay: delay + (i % 3)*24, easing: 'cubic-bezier(.2,.7,.3,1)' });
          }
        };
        burst(start, 8, 46);
        const target = [...document.querySelectorAll('[data-aa-wish-open]')].find(button => {
          const rect = button.getBoundingClientRect();
          return rect.width && rect.height && rect.top >= 0 && rect.bottom <= innerHeight && rect.left >= 0 && rect.right <= innerWidth;
        });
        if (target) {
          const destination = (target.querySelector('svg') || target).getBoundingClientRect();
          const end = { x: destination.left + destination.width / 2, y: destination.top + destination.height / 2 };
          const distance = Math.hypot(end.x-start.x, end.y-start.y);
          const duration = Math.min(1050, Math.max(700, distance*.7));
          const control = { x: start.x + (end.x-start.x)*.42, y: Math.max(12, Math.min(start.y,end.y)-80) };
          const point = (t) => ({ x: (1-t)*(1-t)*start.x + 2*(1-t)*t*control.x + t*t*end.x, y: (1-t)*(1-t)*start.y + 2*(1-t)*t*control.y + t*t*end.y });
          const frames = Array.from({ length: 25 }, (_, i) => {
            const t = i/24;
            const p = point(t);
            return { offset: t, transform: pose(p.x,p.y,27,1.12-t*.46,Math.sin(t*Math.PI)*-18), opacity: t === 1 ? 0 : t === 0 ? .5 : 1 };
          });
          animate(piece('heart'), frames, { duration, delay: 70, easing: 'linear' });
          for (let i = 1; i <= 8; i++) {
            const t = i/10;
            const p = point(t);
            animate(piece('spark'), [
              { transform: pose(p.x,p.y,12,.7), opacity: .8 },
              { transform: pose(p.x+(i%2 ? 9 : -9),p.y+18,12,.05,60), opacity: 0 }
            ], { duration: 330, delay: 70+duration*t });
          }
          burst(end, 6, 28, duration+30);
          animate(piece('ring'), [
            { transform: pose(end.x,end.y,38,.35), opacity: 0 },
            { offset: .25, transform: pose(end.x,end.y,38,.8), opacity: .85 },
            { transform: pose(end.x,end.y,38,1.55), opacity: 0 }
          ], { duration: 450, delay: duration+30, easing: 'ease-out' });
          animate(piece('heart'), [
            { transform: pose(end.x,end.y,27,.6), opacity: 0 },
            { offset: .35, transform: pose(end.x,end.y,27,1), opacity: 1 },
            { transform: pose(end.x,end.y,27,.8), opacity: 0 }
          ], { duration: 400, delay: duration+20, easing: 'ease-out' });
        }
        Promise.allSettled(animations).then(() => { layer.remove(); if (this.flightLayer === layer) this.flightLayer = null; });
      }
      announce(message) {
        clearTimeout(this.timer);
        this.status.textContent = message;
        this.dialogStatus.textContent = message;
        this.timer = setTimeout(() => { this.status.textContent = ''; this.dialogStatus.textContent = ''; }, 4000);
      }
      render() {
        const fragment = document.createDocumentFragment();
        this.items.forEach(item => {
          const row = document.createElement('li');
          row.className = 'aa-wish-item';
          const imageLink = document.createElement('a');
          imageLink.href = item.url;
          imageLink.tabIndex = -1;
          imageLink.setAttribute('aria-hidden','true');
          if (item.image) {
            const image = document.createElement('img');
            image.src = item.image; image.alt = ''; image.width = 90; image.height = 113; image.loading = 'lazy'; image.className = 'aa-wish-item__image';
            imageLink.append(image);
          } else { const placeholder = document.createElement('span'); placeholder.className = 'aa-wish-item__image'; imageLink.append(placeholder); }
          const info = document.createElement('div');
          const title = document.createElement('a');
          title.className = 'aa-wish-item__title'; title.href = item.url; title.textContent = item.title;
          const view = document.createElement('a');
          view.className = 'aa-wish-item__view'; view.href = item.url; view.textContent = this.dataset.view;
          info.append(title,view);
          const remove = document.createElement('button');
          remove.type = 'button'; remove.className = 'aa-wish-remove'; remove.dataset.aaWishRemove = item.id; remove.textContent = '×'; remove.setAttribute('aria-label', `${this.dataset.remove}: ${item.title}`);
          row.append(imageLink,info,remove); fragment.append(row);
        });
        this.list.replaceChildren(fragment);
        this.querySelector('[data-aa-wish-empty]').hidden = this.items.length > 0;
        this.querySelector('[data-aa-wish-total]').textContent = this.items.length ? `(${this.items.length})` : '';
      }
      click(event) {
        if (!(event.target instanceof Element)) return;
        const toggle = event.target.closest('[data-aa-wish-toggle]');
        if (toggle) {
          event.preventDefault(); event.stopPropagation();
          const item = this.clean(toggle.dataset);
          if (!item) return;
          const saved = this.items.some(value => value.id === item.id);
          if (!saved && this.items.length >= 100) { this.announce(this.dataset.limit); return; }
          this.items = saved ? this.items.filter(value => value.id !== item.id) : [item,...this.items];
          const persisted = this.persist();
          this.sync();
          if (!saved) { try { this.celebrate(toggle); } catch { this.flightLayer?.remove(); } }
          this.announce(persisted ? (saved ? this.dataset.removed : this.dataset.saved) : this.dataset.storageError);
          return;
        }
        const open = event.target.closest('[data-aa-wish-open]');
        if (open) {
          event.preventDefault(); this.opener = open; this.render(); this.dialogStatus.textContent = '';
          this.dialog.showModal(); document.documentElement.classList.add('aa-wishlist-open'); return;
        }
        if (!this.contains(event.target)) return;
        const remove = event.target.closest('[data-aa-wish-remove]');
        if (remove) {
          const buttons = [...this.list.querySelectorAll('[data-aa-wish-remove]')];
          const index = buttons.indexOf(remove);
          this.items = this.items.filter(item => item.id !== remove.dataset.aaWishRemove);
          const persisted = this.persist(); this.sync(); this.render();
          const remaining = [...this.list.querySelectorAll('[data-aa-wish-remove]')];
          (remaining[Math.min(index,remaining.length-1)] || this.querySelector('[data-aa-wish-close]')).focus({ preventScroll: true });
          this.announce(persisted ? this.dataset.removed : this.dataset.storageError); return;
        }
        if (event.target.closest('[data-aa-wish-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }
      disconnectedCallback() {
        this.events?.abort(); this.events = null; this.observer?.disconnect(); clearTimeout(this.timer);
        this.flightLayer?.remove();
        document.documentElement.classList.remove('aa-wishlist-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
